import { cacheService } from '@/utils/cache'
import { CACHE_KEYS } from '../constants'

/**
 * İçerik store getters
 */
export const getters = {
  /**
   * Seçili içerik ID'sini döndürür
   * @returns {string|null} Seçili içerik ID'si
   */
  getSelectedContentId: (state) => state.selectedContentId,

  /**
   * Seçili içeriği döndürür
   * @returns {Object|null} Seçili içerik
   */
  getSelectedContent: (state) => {
    // Öncelikle önbellekten kontrol et
    if (state.selectedContentId) {
      const fromCache = cacheService.get(CACHE_KEYS.CONTENT_DETAIL, { contentId: state.selectedContentId })
      if (fromCache) return fromCache
    }

    // Eğer önbellekte yoksa listeden bul
    return state.contentsList.find(content => content.id === state.selectedContentId) || null
  },
}
